<template>
  <div
    class="main"
    v-esc="close"
    v-closable="{ handler: 'close' }"
  >
    <div
      class="opener"
      @click="openclose()"
    >
      <slot name="opener" v-if="$slots.opener"></slot>
      <template v-else>
        <Icon
          class="button"
          symbol="menu"
        />
        {{ title }}
      </template>
    </div>
    <br />
    <slide
      :state="show"
      :duration="300"
      :class="{ content: true, menu: !!items }"
    >
      <slot></slot>
      <div
         v-for="( item, itemK ) of items" :key="itemK + item"
         class="item"
         @click="select( itemK )"
      >{{ item }}</div>
    </slide>
  </div>
</template>

<script>
import Icon from "../components/Icon";
import Slide from "../components/SlideUpDown";

export default {
	name: "Dropdown",

	components: {
    Icon,
    Slide
	},

	props:      {
	  title: {
	    type: String,
      default: null
    },

    items: {
	    type: Array | Object,
      default: null
    }
	},

  data() {
	  return {
	    show: false
    };
  },

	methods:    {
	  openclose() {
	    this.show = !this.show;
    },

	  close() {
	    this.show = false;
    },

    select( itemN ) {
	    this.$emit( "input", itemN );
	    this.close();
    }
	},
};
</script>

<style scoped>
  .main {
    display: inline-block;
    position: relative;
  }

  .opener {
    display: inline-block;
    position: relative;
    cursor: pointer;
  }

  .opener .button {
    transition: all 0.2s ease-in-out;
  }
  .opener:hover .button {
    opacity: 0.8;
  }
  .opener:active .button {
    transform: translate( 1px, 1px );
  }

  .content {
    display: inline-block;
    position: absolute;
    margin-top: 0.5em;
    z-index: 500;
    border-radius: 0.2em;
    padding: 0.5em;
    background-color: #FFFFFF;
    border: solid 1px #0081CA;
    box-shadow: 1px 1px 3px rgba( 0, 0, 0, 0.5 );
  }
  .content[hidden] {
    display: none;
  }
  .content.menu {
    padding: 0;
  }

  .content.menu > .item {
    color: #0081CA;
    padding: 0.5em 1em;
    white-space: nowrap;
    cursor: pointer;
  }
  .content.menu > .item:hover {
    background-color: #0081CA;
    color: #FFFFFF;
  }
</style>
